
































import Vue, { PropType } from 'vue'
import CreateDialog from '@/components/CreateDialog.vue'
import ConfirmInput from './ConfirmInput.vue'
import { Remittance } from '@/utils/interfaces/remittance.interface'
import { deliverRemittance } from '@/api/Remittances/remittances.api'
import { message } from '@/store/modules/notifications'

export default Vue.extend({
  components: {
    appCreateDialog: CreateDialog,
    appConfirmInput: ConfirmInput,
  },
  props: {
    item: Object as PropType<Remittance>,
  },
  data() {
    return {
      rules: {
        required: (v: string) => !!v || this.$t('validation.field-required'),
      },
      delivery_identity: '',
      image: null as null | Blob,
      loading: false,
    }
  },
  computed: {
    computedSrc(): string {
      try {
        return URL.createObjectURL(this.image)
      } catch (error) {
        return ''
      }
    },
  },
  methods: {
    async onSuccess(): Promise<void> {
      try {
        if (!this.image && !this.delivery_identity) {
          const message = {
            title: this.$t('image-or-identity-required'),
            text: this.$t(
              'to-deliver-this-remittance-identity-image-or-number-is-required',
            ),
            description: this.$t(
              'to-deliver-this-remittance-identity-image-or-number-is-required',
            ),
            color: 'info',
            icon: 'mdi-alert',
          } as message
          this.$store.commit('notifications/displayMessage', message)
          return
        }

        this.loading = true
        await deliverRemittance(
          this.item.remittance,
          this.image,
          this.delivery_identity,
        )
        this.item.status = 'Delivered'
        this.$emit('input', false)
      } finally {
        this.loading = false
      }
    },
  },
  watch: {
    '$attrs.value'(value: boolean): void {
      if (value) {
        this.delivery_identity = ''
        this.image = null
      }
    },
  },
})
